import { Text } from '@byecode/ui'
import { NavigationShowMode } from '@lighthouse/core'
import React, { useMemo } from 'react'

import { RoundAvatar } from '@/components/RoundAvatar'

import * as SC from './styles'
import type { PlatformProps } from './types'

export const WxApplet: React.FC<PlatformProps> = ({
    iconColor,
    appName,
    appIcon,
    activeBandColor,
    iconBackground,
    color,
    layout = NavigationShowMode.horizontal,
    navBackgroundColor
}) => {
    const title = useMemo(() => {
        if (appName) {
            return (
                <Text color={color} style={{ flex: 1 }} size={20}>
                    {appName}
                </Text>
            )
        }
        return (
            <SC.AppNav>
                <SC.CrossBand width={88} height={20} borderRadius={8} background={activeBandColor} />
            </SC.AppNav>
        )
    }, [activeBandColor, appName, color])

    const content = useMemo(() => {
        return (
            <SC.Content isHorizontal={layout === NavigationShowMode.horizontal} background={navBackgroundColor}>
                <SC.AppMobileHeader pr={16} alignItems="center" justifyContent="space-between">
                    <SC.AppInfo isHorizontal={layout === NavigationShowMode.horizontal}>
                        <RoundAvatar
                            iconSize={24}
                            size={32}
                            type="icon"
                            radius="8px"
                            bordered={false}
                            iconColor={iconColor}
                            icon={appIcon}
                            background={iconBackground}
                        />
                        {title}
                    </SC.AppInfo>
                    <SC.AppNav>
                        <SC.CrossBand width={57} height={28} borderRadius={100} background={activeBandColor} />
                    </SC.AppNav>
                </SC.AppMobileHeader>
            </SC.Content>
        )
    }, [activeBandColor, appIcon, iconBackground, iconColor, layout, navBackgroundColor, title])

    return (
        <SC.WxApplet>
            {content}
            <SC.AppMobileContent>
                {Array.from({ length: 8 }).map((_, index) => (
                    <SC.Box key={index} />
                ))}
            </SC.AppMobileContent>
        </SC.WxApplet>
    )
}
